export Layout from './layout';
export Login  from './login';
export SignUp from './signup';
export Recover from './recover';
export ResetPassword from './reset-password';



// WEBPACK FOOTER //
// ./src/components/auth/index.js